/**
 * Simula una chiamata asincrona che ritorna dati mock
 * @param data - I dati mock da ritornare
 * @param delay - Ritardo in millisecondi (default: 1000ms)
 * @param shouldFail - Se true, la promise viene rigettata (default: false)
 * @returns Promise che risolve con i dati in formato JSON
 */
export function mockAsyncCall<T>(
    data: T,
    delay: number = 1000,
    shouldFail: boolean = false
): Promise<T> {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (shouldFail) {
                reject(new Error('Mock API call failed'));
            } else {
                resolve(data);
            }
        }, delay);
    });
}
